/*
 *   File : confirm-delete-bank.js
 *   Author : https://evoqins.com
 *   Description : Bank delete confirm modal
 *   Integrations : NA
 *   Version : 1.0.0
*/


import React from 'react';

//custom component
import { PrimaryButton, SecondaryButton } from '../Buttons';

//Assets
import DeleteImg from "../../Assets/Images/KYC/kyc-failure.png";
import Close from "../../Assets/Images/close-btn-white.svg";

const ConfirmDeleteBankModal = (props) => {

    return (
        <div className="modal fade"
            data-bs-backdrop="static"
            id="bank-delete-modal"
            tabIndex="-1"
            aria-labelledby="ConfirmDeleteBankModalLabel"
            aria-hidden="true">
            <div className="modal-dialog  modal-dialog-centered" >
                <div className="modal-content e-bg-blur-gradient e-border-radius-24 e-addbank-box-shadow">
                    <button id='bank-delete-modal-close-btn' data-bs-dismiss="modal" className='d-none'></button>
                    <div className="modal-header border-0 justify-content-end pt-4 pb-0 px-4 ">
                        <img src={Close}
                            id='bank-delete-modal-close'
                            draggable={false}
                            className='cursor-pointer width-24px-res'
                            data-bs-dismiss="modal"
                            aria-label="Close"
                            alt='close'
                            onClick={props.onCloseModal}
                        />
                    </div>
                    <div className="modal-body text-center p-4 ">
                        <img src={DeleteImg}
                            draggable={false}
                            className='col-5'
                            alt='bank' />
                        <p className='mb-2 pt-4 e-text-sunset-orange e-font-16-res e-font-18 e-alt-font-poppins e-font-weight-600 line-height-24px'>
                            Delete Account
                        </p>
                        <p className='e-font-12-res mb-0 px-md-4 px-sm-0 px-0 e-text-dark-liver e-font-14 e-alt-font-poppins e-font-weight-400 line-height-24px'>
                            You are about to permanently delete your bank account ending in {props.bankNumber}. This action is irreversible.
                        </p>

                        <div className='d-flex flex-sm-column justify-content-center align-items-center gap-3  padding-32px-top'>
                            <PrimaryButton name={"Delete"}
                                loading={props.loading}
                                disabled={props.loading}
                                className="padding-8px-all-res padding-14px-top padding-12px-bottom col-6 col-sm-9 e-font-14"
                                onPress={props.onDeleteBank} />
                            <SecondaryButton name="Cancel"
                                dismiss="modal"
                                borderRadius="e-border-radius-10"
                                className="padding-8px-all-res e-text-egyptian-blue padding-12px-top padding-12px-bottom col-6 col-sm-9 e-font-14 e-border-1px-egyptian-blue"
                                onPress={props.onCloseModal} />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ConfirmDeleteBankModal